import { Observable } from "rxjs";

export interface OPDSequenceMSt {
        id?: number,
        keyword:string,
        textDesc:string,
        dateFormat:string,
        numberStart:number,
        length:number, 
        resetBy:string,
        type:string,
        typeCode:string,
        branchCode:string,
        dateSeparationText:string,
        textSeparationText:string,
        numberSeparationText:string,
        sequenceBy:string;
        createdDate:Date,
        updatedDate:Date,
        createdBy: number,
        updatedBy: number,
        tenantId:any, 
        branchId:any 
}

export interface OPDLogMst {
    id?: number,
    queueStatus:string,
    queueTime:Date,
    queueDescription:string,
    appointmentId: any,
    createdIp: string,
    updatedIp: string,
    createdDate:Date,
    updatedDate:Date,
    createdBy: number,
    updatedBy: number,
    tenantId:any, 
    branchId:any,
    apptFromDate:any,
    apptToDate:any,
    visitId?:number,
    regId?:string,
    entryFrom?:string,
    referenceId?:string
}


export abstract class OPDSequenceMStData {
    abstract getById(url: string): Observable<any>;
    abstract list(url: string): Observable<OPDSequenceMSt[]>;
    abstract create(url: string, data: any): Observable<any>;
    abstract update(url: string, data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;   
    abstract updateHealthCard(url: string, data: any): Observable<any>;
}